export function RenderPublishedText({
  text,
  accentColor,
}: {
  text?: string;
  accentColor?: string;
}) {
  if (text) {
    // add anchor tags to any urls in the text that start with http
    const urlRegex = /(http?[^\s]+)/g;
    const parts = text.split(urlRegex);
    return (
      <span className="publishedText">
        {parts.map((part, index) =>
          urlRegex.test(part) ? (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              style={accentColor ? { color: `${accentColor}` } : undefined}
            >
              {part.replaceAll("https://", "").replaceAll("http://", "")}
            </a>
          ) : (
            <RenderArrayText text={part} accentColor={accentColor} />
          ),
        )}
      </span>
    );
  }
  return <span className="publishedText">{text}</span>;
}

export function RenderArrayText({
  text,
  accentColor,
}: {
  text: string;
  accentColor?: string;
}) {
  const arrayRegex = /(\[[^\]]*\])/;
  const parts = text.split(arrayRegex);

  return parts.map((part, index) => {
    if (part.startsWith("[") && part.endsWith("]")) {
      const textArray = part
        .replaceAll("[", "")
        .replaceAll("]", "")
        .split(",")
        .map(item => item.trim());
      const largestWord = textArray.reduce(
        (longest, word) => (word.length > longest.length ? word : longest),
        "",
      );
      return (
        <ul
          key={index}
          className="arrayText"
          style={accentColor ? { color: `${accentColor}` } : undefined}
        >
          <span className="arrayBuffer">{largestWord}</span>
          {textArray.map((tPart, tIndex) => (
            <li
              key={tIndex}
              className="arrayTextItem"
              style={{
                animation:
                  (textArray.length === tIndex + 1 ? "flyInStay" : "flyIn") +
                  " 3s linear forwards",
                animationDelay: tIndex * 3 + "s",
                fontSizeAdjust: "200%",
              }}
            >
              <strong>{tPart}</strong>
            </li>
          ))}
        </ul>
      );
    }
    return part;
  });
}
